import { render, staticRenderFns } from "./RegisterKazykurt.vue?vue&type=template&id=133c620a&scoped=true&"
import script from "./RegisterKazykurt.vue?vue&type=script&lang=js&"
export * from "./RegisterKazykurt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133c620a",
  null
  
)

export default component.exports